import { DimeDetailCardShell } from '../DimeDetailCardShell.js';
import type { DimeDetailLayoutPaneCard } from './DimeDetailLayout.types.js';

export function DimeDetailLayoutRightPaneCard({
  card,
}: Readonly<{ card: DimeDetailLayoutPaneCard }>) {
  if ('node' in card) return card.node;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- destructure-drop key, which React takes on the element, not the shell's props
  const { key, ...shellProps } = card;
  return <DimeDetailCardShell {...shellProps} />;
}
